import React from "react";
import Layout from "./utilities/Layout";
import WaitingList from "./WaitingList";
import { withRouter } from "react-router-dom";

class WaitingRoom extends React.Component {
  render() {
    return (
      <Layout
        params={this.props.match.params}
        history={this.props.history}
        title="Salle d'attente"
      >
        <WaitingList />
      </Layout>
    );
  }
}
export default withRouter(WaitingRoom);



// WEBPACK FOOTER //
// ./src/components/WaitingRoom.js